import React from 'react';
import PropTypes from 'prop-types';
// Local Deps
import './ToolingManagementMenu.scss';
import msgs from '../../config/messages';
import NFButton from '../primitives/NFButton';
import ToolingManagementCaps from '../../config/searchFilters/ToolingManagementFilters';
import Loading from '../Loading';

// Components
import FilterGroup from '../FilterGroup';

export default class ToolingManagementMenu extends React.PureComponent {
  static propTypes = {
    selectedMenu: PropTypes.object,
    onMenuClick: PropTypes.func,
    onToolFilter: PropTypes.func.isRequired,
    isDownloading: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    selectedMenu: { value: 'toolingGrid' },
    onMenuClick: () => { },
  };

  _clearPartNumDes = () => {
    document.getElementById('partNum').value = '';
    document.getElementById('description').value = '';
  };
  _clearNiinDesc = () => {
    document.getElementById('niin').value = '';
    document.getElementById('description').value = '';
  };
  _clearNiinPartNum = () => {
    document.getElementById('niin').value = '';
    document.getElementById('partNum').value = '';
  };

  _clearFilters = () => {
    window.location.reload();
  };

  render() {
    const { selectedMenu, onMenuClick, onToolFilter, isDownloading } = this.props;
    return (
      <div className="nf-solicitations-menu">
        <FilterGroup
          {...ToolingManagementCaps}
          onFilterClick={onMenuClick}
          selectedFilter={[selectedMenu.value]}
        />
        {isDownloading && (
          <Loading
            text="Downloading File"
          />
        )}
        {selectedMenu.value === 'toolingGrid' && (
          <div className="nf-tool-filter-group">
            <h6 className="nf-tool-filter-group-header">Search Tooling Management Records</h6>
            <span className="ant-input-wrapper ant-input-group" style={{ 'margin-bottom': 6 }}>
              <span className="ant-input-group-addon">NSN/NIIN</span>
              <input
                name="niin"
                id="niin"
                type="text"
                className="ant-input"
                onClick={this._clearPartNumDes}
              />
            </span>

            <span className="ant-input-wrapper ant-input-group" style={{ 'margin-bottom': 6 }}>
              <span className="ant-input-group-addon">Part Number</span>
              <input
                name="partNum"
                id="partNum"
                type="text"
                className="ant-input"
                onClick={this._clearNiinDesc}
              />
            </span>

            <span className="ant-input-wrapper ant-input-group" style={{ 'margin-bottom': 6 }}>
              <span className="ant-input-group-addon">Description</span>
              <input
                name="description"
                id="description"
                type="text"
                className="ant-input"
                onClick={this._clearNiinPartNum}
              />
            </span>


            <div className="nf-tool-filter-buttons">
              <NFButton
                className="nf-button--gray-border"
                onClick={this._clearFilters}
              >
                Reset
              </NFButton>
              <NFButton
                className="nf-button--form nf-tooling-button nf-button--orange"
                onClick={onToolFilter}
              >
                {msgs.Form.submitButton}
              </NFButton>
            </div>


          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ToolingManagementMenu/ToolingManagementMenu.jsx